import request from '../../../lib/helpers/requestApi';
import { CounteragentsList, CounteragentsListParams, OrdList } from './types';

export const getCounteragentsListAPI = request<CounteragentsList, CounteragentsListParams>({
  method: 'counteragent.getList',
});

export const getOrdListAPI = request<OrdList>({
  method: 'counteragent.getOrdList',
});

